import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { DataServiceService } from '../data-service.service';
import { Result } from '../model/result';

@Component({
  selector: 'app-result-sanction',
  templateUrl: './result-sanction.component.html',
  styleUrls: ['./result-sanction.component.scss']
})
export class ResultSanctionComponent implements OnInit {

  chinese_string = ""
  isChineseSearch: boolean = localStorage.getItem("isChineseSearch") == 'true'?true:false;
  isIndividualSearch: boolean = localStorage.getItem("isIndividualSearch") == 'true'?true:false;
  showSuccessMsg: boolean = false;
  isSavingRecord: boolean = false
  individualData = JSON.parse(localStorage.getItem('data'))
  entityData = JSON.parse(localStorage.getItem('data'))

  constructor(
    private dataService: DataServiceService,
    private router: Router,
    private authService: AuthService,
    private location: Location
  ) { }

  goBack() {
    localStorage.setItem("skipSearchOnBack", "true");
    localStorage.setItem("skipSearchOnBackTs", Date.now().toString());
    this.location.back();
  }

  ngOnInit(): void {
    this.chinese_string = this.isChineseSearch ? localStorage.getItem('chinese_string') : ""
  }

  saveRecord(){
    this.isSavingRecord = true
    var currentDate = new Date()

    var historyObj = {}

    historyObj['userEmail'] = this.authService.getCurrentUser().email;
    
    this.individualData['saveDate'] = `${currentDate.getDate()}/${currentDate.getMonth()+1}/${currentDate.getFullYear()}`;
    this.individualData['saveTime'] = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    this.individualData['UTCsaveDate'] = `${currentDate.getUTCDate()}/${currentDate.getUTCMonth()+1}/${currentDate.getUTCFullYear()}`;
    this.individualData['UTCsaveTime'] = `${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:${currentDate.getUTCSeconds()}`;
    this.individualData['type'] = 'SANCTION'
    
    historyObj['historyData'] = [this.individualData]

    this.dataService.saveSearchResult(historyObj)
    .then((data)=>{
      if(data['msg'] == 'Saved record'){
        this.isSavingRecord = false
        this.showSuccessMsg = true;
        setTimeout(() => {
          this.showSuccessMsg = false;
        }, 5000);
      }
      else{
        alert('Failed to save record. Please try after some time')
      }
    })
  }
}